import { Link, Outlet, createFileRoute } from "@tanstack/react-router";

import { useT } from "../i18n/I18nProvider";

/** The same underline as the band's navigation (SP-032), on the page background. */
const TAB =
  "-mb-px border-b-[3px] border-transparent pb-2.5 font-semibold whitespace-nowrap text-muted-foreground no-underline hover:text-foreground hover:no-underline";
const TAB_ACTIVE = { className: "border-primary! text-foreground!" };

export const Route = createFileRoute("/app/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  const t = useT();
  return (
    <>
      <h1>{t("settings.title")}</h1>
      <nav className="my-4 flex gap-6 overflow-x-auto border-b text-sm">
        <Link to="/app/settings/profile" className={TAB} activeProps={TAB_ACTIVE}>
          {t("settings.profile.title")}
        </Link>
        <Link to="/app/settings/products" className={TAB} activeProps={TAB_ACTIVE}>
          {t("settings.products.title")}
        </Link>
        <Link to="/app/settings/security" className={TAB} activeProps={TAB_ACTIVE}>
          {t("settings.security.title")}
        </Link>
        <Link to="/app/settings/billing" className={TAB} activeProps={TAB_ACTIVE}>
          {t("settings.billing.title")}
        </Link>
        <Link to="/app/settings/privacy" className={TAB} activeProps={TAB_ACTIVE}>
          {t("settings.privacy.title")}
        </Link>
        <Link to="/app/settings/tracking" className={TAB} activeProps={TAB_ACTIVE}>
          {t("settings.tracking.title")}
        </Link>
        <Link to="/app/settings/autopilot" className={TAB} activeProps={TAB_ACTIVE}>
          {t("settings.autopilot.title")}
        </Link>
      </nav>
      <Outlet />
    </>
  );
}
